module.exports = __webpack_public_path__ + "static/media/MrWalkerStepsOutJacket.1f453616.jpg";